<template>
  <div>
    <div
        v-if="notification && notification.showNotification"
        class="notification"
        :class="notification.error ? 'is-danger' : 'is-primary'"
    >
      {{ notification.message }}
    </div>
  <v-dialog
      v-if="notification && notification.showDialog"
      v-model="notification.showDialog"
      :max-width="maxWidth"
      :fullscreen="isFullScreen"
  >
    <v-card>
      <v-toolbar
          dark
          :color="notification.error ? 'error' : 'primary'"
      >
        <v-btn
            icon
            dark
            @click="closeDialog"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{headerText}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn
              dark
              text
              @click="notification.showDialog = false"
          >
            Ok
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text style="padding-top:20px; font-size:18px"><b>{{notification.message}}</b></v-card-text>
    </v-card>
  </v-dialog>
  </div>
</template>
<style scoped>
</style>
<script>
  export default {
    name: 'Notification',
    props: ['notification'],
    data () {
      return {
      }
    },
    computed: {
      headerText() {
        return this.notification.error ? "Error" : "Success";
      },
      isFullScreen() {
        return (this.$mq === 'sm' || this.$mq === 'xs' || this.$mq === 'mobile')
      },
      maxWidth() {
        return this.isFullScreen ? "auto" : "500px"
      }
    },
    methods: {
      closeDialog() {
        this.$set('notification', 'showDialog', false);
      }
    }
  }
</script>